import { Post } from '@planone/bau365/util-fair-data';

import { staticExhibitors } from './data-access-exhibitor.static.mocks';
import { staticPosts } from './data-access-post.static.mocks';
import { ProductMockGenerator } from './data-access-product.service.mocks';
import { describedImageMock, linkMock, videoMock } from './generic.mocks';

export const postMock: Post = {
  id: '1',
  exhibitor_id: '1',
  fair_id: 'bau23',
  headline: 'My Post',
  summary: 'My awesome post summary.',
  published_at: '2014-04-07T13:58:10.104Z',
  content: 'My awesome post content.',
  authors: [
    {
      id: '1',
      title: '',
      first_name: 'Ihr',
      name: 'Ansprechpartner',
      roles: ['Kundenbetreuung'],
      email: 'irgendwas@plan.one',
      phone: '08773 18-78889256',
      mobile: '',
      avatar: {
        description: '',
        resource: 'assets/mock-exhibitor-page/contactPersonIMG.webp',
        provider: 'RAW',
      },
    },
    {
      id: '2',
      title: '',
      first_name: 'Ihr',
      name: 'Ansprechpartner',
      roles: ['Kundenbetreuung'],
      email: 'irgendwas@plan.one',
      phone: '08773 18-78889256',
    },
    {
      id: '3',
      title: '',
      first_name: 'Ihr',
      name: 'Ansprechpartner',
      roles: ['Kundenbetreuung'],
      email: 'irgendwas@plan.one',
      phone: '08773 18-78889256',
    },
    {
      id: '4',
      title: '',
      first_name: 'Ihr',
      name: 'Ansprechpartner',
      roles: ['Kundenbetreuung'],
      email: 'irgendwas@plan.one',
      phone: '08773 18-78889256',
      mobile: '',
      avatar: {
        description: '',
        resource: 'assets/mock-exhibitor-page/contactPersonIMG.webp',
        provider: 'RAW',
      },
    },
  ],
  topics: [],
  product_groups: [],
  products: ['1'],
  professions: [],
};

export class PostMockGenerator {
  static elements = 30;
  static mockData = {
    ...postMock,
  };

  static getIds(exhibitor_id: string | undefined = undefined) {
    if (exhibitor_id && Object.keys(staticExhibitors).includes(exhibitor_id)) {
      return Object.values(staticPosts)
        .filter((post: Post) => post.exhibitor_id === exhibitor_id)
        .map((post: Post) => post.id);
    }

    return [...Array(PostMockGenerator.elements).keys()].map((value) => <string>(<unknown>value));
  }

  static getList(
    ids: string[] | undefined = undefined,
    fair_id: string | undefined,
    exhibitor_id: string | undefined = undefined
  ) {
    return PostMockGenerator.getIds(exhibitor_id)
      .filter((id: string) => (id ? (ids ? ids.includes(<string>(<unknown>id)) : true) : false))
      .map((id: string) => PostMockGenerator.getObject(<string>(<unknown>id), fair_id, exhibitor_id));
  }

  static getPaginatedList(fair_id: string | undefined, exhibitor_id: string | undefined = undefined) {
    return {
      cursors: {
        next: undefined,
        prev: undefined,
      },
      items: PostMockGenerator.getList(undefined, fair_id, exhibitor_id),
    };
  }

  static getObject(id: string, fair_id: string | undefined, exhibitor_id: string | undefined = undefined) {
    if (staticPosts[id]) {
      return staticPosts[id];
    }

    return <Post>{
      ...PostMockGenerator.mockData,
      id: <string>(<unknown>id),
      fair_id: fair_id,
      exhibitor_id: exhibitor_id ? exhibitor_id : '0',
      published_at: '2014-04-07T13:58:10.104Z',
      headline: PostMockGenerator.mockData.headline + ' ' + <string>(<unknown>id),
      products: ProductMockGenerator.getIds().map((id: string) => <string>(<unknown>id)),
      gallery: [
        describedImageMock(),
        describedImageMock(),
        describedImageMock(),
        describedImageMock(),
        describedImageMock(),
        describedImageMock(),
      ],
      downloads: [
        {
          name: 'Aluminium-Fenstersystemen',
          file_name: 'Aluminium-Fenstersystemen',
          size: '20,40',
          path: 'https://www.plan.one',
        },
        {
          name: 'Schüco Livlng Classic',
          file_name: 'Schüco Livlng Classic',
          size: '8,20',
          path: 'https://www.bau365.de',
        },
        {
          name: 'Rondo',
          file_name: 'Schüco Livlng Rondo',
          size: '4,80',
          path: 'https://www.bau365.de',
        },
      ],
      links: [linkMock, linkMock, linkMock, linkMock, linkMock, linkMock],
      videos: [videoMock, videoMock, videoMock, videoMock, videoMock, videoMock, videoMock],
      authors:
        PostMockGenerator.mockData.authors?.map((contact) => {
          return {
            ...contact,
            avatar: describedImageMock(),
            description:
              'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet,',
            social_media: {
              linked_in: 'https://plan.one',
              xing: 'https://plan.one',
              instagram: 'https://plan.one',
              facebook: 'https://plan.one',
              twitter: 'https://plan.one',
              youtube: 'https://plan.one',
              pinterest: 'https://plan.one',
              tiktok: 'https://plan.one',
            },
            title: 'Prof. Dr.',
            first_name: 'Max',
            name: 'Mustermann',
            phone: '00000 0000000',
            mobile: '00000 0000000',
            fax: '00000 0000000',
            email: 'max@mustermann.de',
            website: 'https://plan.one',
          };
        }) ?? [],
    };
  }
}
